import { Outlet } from "react-router";
import { LandingNavRight } from "~/features/landing/LandingNavRight";
import { PublicFooter } from "~/features/public/Footer";
import { NavBar } from "~/features/public/NavBar";

export default function Pages() {
  return (
    <div className="min-h-screen bg-white text-slate-950 antialiased">
      <NavBar logoTo="/" navItems={[]} right={<LandingNavRight />} />
      <main className="public-container py-10">
        <Outlet />
      </main>
      <PublicFooter />
    </div>
  );
}
